var map = {
	"./footer-links.de-CH.json": 989,
	"./footer-links.de-DE.json": 990,
	"./footer-links.en-CA.json": 991,
	"./footer-links.en-GB.json": 992,
	"./footer-links.en-IN.json": 993,
	"./footer-links.en-ME.json": 994,
	"./footer-links.en-US.json": 995,
	"./footer-links.es-EM.json": 996,
	"./footer-links.es-ES.json": 997,
	"./footer-links.fr-BE.json": 998,
	"./footer-links.fr-CA.json": 999,
	"./footer-links.fr-CH.json": 1000,
	"./footer-links.nl-BE.json": 1001,
	"./footer-links.nl-NL.json": 1002,
	"./footer-links.pl-PL.json": 1003,
	"./footer-links.pt-BR.json": 1004
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 988;